<div class="relative w-full">
  <input
    [type]="type"
    [placeholder]="placeholder"
    [formControl]="control"
    [maxlength]="maxlength"
    class="input dark:!bg-secondary dark:!outline-secondary dark:!text-white"
    [class.border-red-500]="required && control.errors?.['required'] && control.touched"
  />

  <div
    *ngIf="required && control.errors?.['required'] && control.touched"
    class="text-red-500 text-sm mt-1"
  >
    This field is required
  </div>
</div>
